import React from 'react';
import ChevronDown from 'pubweb-smokey/dist/images/svg/iconography-16x16/chevron-dwn.svg';
import LocationPin from 'pubweb-smokey/dist/images/svg/iconography-16x16/location-line.svg';

type Props = {
  postalCode: string;
  distance: number;
  onPointerDown: () => void;
};

export default function LocationButton({
  postalCode,
  distance,
  onPointerDown,
}: Props): JSX.Element {
  return (
    <>
      <div
        className="location-button-desktop"
        onPointerDown={() => onPointerDown()}
      >
        {postalCode && distance ? (
          <>
            <LocationPin viewBox="0 0 16 12" />
            <p className="h5">
              {distance} miles of {postalCode}
            </p>
          </>
        ) : (
          <>
            <p>Please provide a zip code</p>
            <p className="zipError"></p>
          </>
        )}
        <ChevronDown viewBox="0 0 16 12" />
      </div>

      <div
        className="location-button-mobile standard filter-button"
        onPointerDown={() => onPointerDown()}
      >
        {postalCode ? postalCode : 'ZIP'}
      </div>
    </>
  );
}
